import { BadgeState } from '@kubit/web-ui-components/badge/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { BadgeNotificationVariant } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [BadgeNotificationVariant.REGULAR]: {
            [BadgeState.DEFAULT]: {
                container: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_100,
                },
                labelContainer: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    min_width: FOUNDATIONS.size_450,
                    max_width: FOUNDATIONS.size_900,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_500,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                icon: {
                    width: FOUNDATIONS.size_350,
                    height: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_comp_feedback_badgenotifications_icon,
                },
            },
            [BadgeState.ACTIVE]: {
                container: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_100,
                },
                labelContainer: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    min_width: FOUNDATIONS.size_450,
                    max_width: FOUNDATIONS.size_900,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_500,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                icon: {
                    width: FOUNDATIONS.size_350,
                    height: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_comp_feedback_badgenotifications_icon,
                },
            },
            [BadgeState.DISABLED]: {
                container: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_100,
                    cursor: 'default',
                },
                labelContainer: {
                    display: 'flex',
                    flex_direction: 'column',
                    justify_content: 'center',
                    align_items: 'center',
                    min_width: FOUNDATIONS.size_450,
                    max_width: FOUNDATIONS.size_900,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_500,
                    font_weight: FONT_WEIGHT.font_regular,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                icon: {
                    width: FOUNDATIONS.size_350,
                    height: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                dotContainer: {
                    display: 'none',
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map